// extracted by mini-css-extract-plugin
module.exports = {"Contact":"styles_Contact__2ozzQ","fadeIn":"styles_fadeIn__16XvH"};